var map = {
	"./1 Thumbnail, title_ BNN RI-TNI Jadikan Lembaga Pendidikan Dan Pelatihan Sebagai Tempat Rehabilitasi Penyalahguna Narkoba.jpg": 20643,
	"./2 Thumbnail, title_ Deputi Bidang Rehabilitasi BNN RI Adakan Pelatihan IBM.jpg": 30798,
	"./3 Thumbnail, title_ Berikan Layanan Rehabilitasi Ramah Anak, Deputi Rehabilitasi BNN RI Raih Penghargaan Dari Kementerian PP Dan PA.jpg": 89112,
	"./4 Thumbnail, title_ Penuhi SNI 8807_2022, BNN RI Pertajam Pemahaman Petugas Rehabilitasi Tentang Wawancara Motivasi.jpg": 86134,
	"./5 Thumbnail, title_ BNN RI Bahas Profesionalisasi dan Standarisasi Layanan Rehabilitasi pada Working Group Discussion ASOD.jpg": 90062,
	"./6 Thumbnail, title_ Tingkatkan Kualitas Layanan Rehabilitasi Melalui Badan Standardisasi Nasional.jpg": 63682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81861;